<template>
  <div class="container" v-if="event">
    <h1 class="page-title"><b>{{ $t('payment_failed.titles.' + event.toLowerCase()) }}</b></h1>
    <div>
      <div v-if="event === PaymentResponseEvent.FAIL" class="text-left">
        <div>{{ $t('payment_failed.failed_transaction') }}</div>
        <div>{{ $t('payment.simplepay_transaction_id', { id: transactionId }) }}</div>
        <div class="mt-3">{{ $t('payment_failed.failed_transaction_description') }}</div>
      </div>
      <div v-else-if="event === PaymentResponseEvent.TIMEOUT">
        {{ $t('payment_failed.timeout_description') }}
      </div>
      <div v-else-if="event === PaymentResponseEvent.CANCEL">
        {{ $t('payment_failed.cancel_description') }}
      </div>
      <div class="sc-thanks-main-page">
        <router-link :to="invoiceUrl">
          <rounded-button color="primary" @click="back()">
              {{ $t('common.retry') }}
          </rounded-button>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { PaymentResponseEvent } from '../models/PaymentResponse'
import { Routes } from '../utils/Routes'
import thanksMixin from '../mixins/thanks.mixin'
import RoundedButton from '../../shared/components/RoundedButton'

export default {
  name: 'PaymentFailed',
  components: {
    RoundedButton
  },

  mixins: [thanksMixin],

  created () {
    if (!this.$route.query.response) {
      this.$router.push(Routes.home())
      return
    }

    this.paymentResponse = JSON.parse(atob(this.$route.query.response))
    this.$ga && this.$ga.event({
      eventCategory: 'Order or Purchase',
      eventAction: 'Failed'
    })
  },

  data () {
    return {
      steps: [],
      PaymentResponseEvent,
      paymentResponse: {}
    }
  },

  computed: {
    event () {
      return this.paymentResponse.event
    },
    invoiceUrl () {
      return Routes.INVOICE.path.replace(':invoiceId', this.paymentResponse.invoiceId).replace(':key', this.paymentResponse.invoiceKey)
    }
  },

  methods: {
    back () {
      this.$router.push(Routes.PAYMENT.path)
    }
  }
}
</script>

<style scoped lang="scss">
.container {
  margin: auto;
  width: 80%;
}
.card-row {
  width: 100%;
  display: inline-flex;
}
.card-first-row {
  width: 50%;
}
.sc-thanks-card {
  width: 100%;
  box-shadow: 0px 1px 1px 1px rgba(220,220,220, 0.4);
}
.sc-thanks-main-page {
  width: 200px;
  margin: 30px auto;
}
.sc-thanks-bank-data-container {
  color: $sc-text-dark;
  width: 75%;
}
.sc-thanks-bank-data-hr {
  margin: 10px 0px;
}
</style>
